(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gnd-custom-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=()=>document.querySelectorAll('.gc-inquiry-card').forEach(card=>{
  if(card.dataset.gndFormStyled)return;card.dataset.gndFormStyled='true';
  const apply=()=>{const host=card.querySelector('shopify-forms-embed');if(!host?.shadowRoot)return false;if(!host.shadowRoot.querySelector('[data-gnd-form-style]')){const style=document.createElement('style');style.dataset.gndFormStyle='true';style.textContent='form button[type="submit"]{font-size:15px!important;font-weight:400!important;min-height:50px;box-sizing:border-box;transition:background .2s,color .2s}form button[type="submit"]:hover,form button[type="submit"]:focus-visible{background:#d4b77c;color:#111;filter:none}';host.shadowRoot.append(style)}return true};
  if(apply())return;const observer=new MutationObserver(()=>{if(apply())observer.disconnect()});observer.observe(card,{childList:true,subtree:true});let tries=0;const timer=setInterval(()=>{if(apply()||++tries>30){clearInterval(timer);observer.disconnect()}},500);
 });
 init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnd-custom-story"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=root=>{
  if(root.dataset.v2Ready)return; root.dataset.v2Ready='true';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'), desktop=matchMedia('(min-width:900px)');
  const scene=root.querySelector('.gc-hero-scene'),hero=root.querySelector('.gc-hero'),stage=root.querySelector('.gc-gallery-stage'),pin=root.querySelector('.gc-gallery-pin'),win=root.querySelector('.gc-gallery-window'),track=root.querySelector('.gc-grid'),cards=[...root.querySelectorAll('.gc-card')],bar=root.querySelector('.gc-progress span'),count=root.querySelector('.gc-gallery-count'),toggle=root.querySelector('.gc-motion-toggle');
  const prev=root.querySelector('.gc-prev'),next=root.querySelector('.gc-next');
  let paused=reduced.matches,travel=0,raf=0,index=0,observer;
  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  const update=()=>{
   raf=0;if(paused)return;
   const rect=scene.getBoundingClientRect();
   const progress=clamp((110-rect.top)/Math.max(1,scene.offsetHeight-hero.offsetHeight),0,1);
   hero.style.setProperty('--gc-hero-shift',`${-progress*110}px`);hero.style.setProperty('--gc-hero-turn',`${progress*12}deg`);hero.style.setProperty('--gc-copy-shift',`${-progress*35}px`);
   if(!desktop.matches)return;
   const top=parseFloat(getComputedStyle(pin).top)||105;
   const r=stage.getBoundingClientRect(),p=clamp((top-r.top)/Math.max(1,travel),0,1);
   const x=p*travel;track.style.setProperty('--gc-track-x',`${-x}px`);
   index=Math.round(p*(cards.length-1));count.textContent=`${String(index+1).padStart(2,'0')} / 09`;
   bar.style.transform=`scaleX(${.111+p*.889})`;prev.disabled=p<=0;next.disabled=p>=1;
   cards.forEach((card,i)=>{const center=card.offsetLeft+card.offsetWidth/2-x;const distance=clamp((center-win.clientWidth/2)/(win.clientWidth/2),-1,1);card.style.setProperty('--gc-card-turn',`${distance*4}deg`);card.style.setProperty('--gc-card-y',`${Math.abs(distance)*13}px`)});
  };
  const schedule=()=>{if(!raf&&!paused)raf=requestAnimationFrame(update)};
  const measure=()=>{travel=Math.max(0,track.scrollWidth-win.clientWidth+4);stage.style.setProperty('--gc-stage-height',`${travel+pin.offsetHeight}px`);update()};
  const setMotion=()=>{root.classList.toggle('gc-motion',!paused);root.classList.toggle('gc-no-motion',paused);toggle.setAttribute('aria-pressed',String(paused));toggle.textContent=paused?'Play motion':'Pause motion';if(paused){prev.disabled=false;next.disabled=false;root.querySelectorAll('.gc-pending').forEach(el=>el.classList.remove('gc-pending'));observer?.disconnect();root.querySelectorAll('.gc-card').forEach(el=>{el.style.removeProperty('--gc-card-turn');el.style.removeProperty('--gc-card-y')})}measure()};
  toggle.addEventListener('click',()=>{if(reduced.matches){toggle.textContent='Reduced motion is enabled';return}paused=!paused;setMotion()});
  reduced.addEventListener('change',()=>{paused=reduced.matches;setMotion()});
  if('IntersectionObserver'in window&&!paused){observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('gc-pending');observer.unobserve(e.target)}}),{threshold:.12});root.querySelectorAll('.gc-reveal').forEach(el=>{if(desktop.matches&&el.classList.contains('gc-card'))return;if(el.getBoundingClientRect().top>innerHeight)el.classList.add('gc-pending');observer.observe(el)})}
  const go=dir=>{if(paused){win.scrollBy({left:dir*(cards[0].offsetWidth+32),behavior:reduced.matches?'auto':'smooth'});return}const step=(cards[0].offsetWidth+32);const x=clamp((parseFloat(getComputedStyle(pin).top)||105)-stage.getBoundingClientRect().top+dir*step,0,travel);const y=scrollY+stage.getBoundingClientRect().top-(parseFloat(getComputedStyle(pin).top)||105)+x;window.scrollTo({top:y,behavior:'smooth'})};
  prev.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));
  cards.forEach(card=>card.querySelector('a').addEventListener('focus',()=>{if(!desktop.matches||paused)return;const x=clamp(card.offsetLeft,0,travel);window.scrollTo({top:scrollY+stage.getBoundingClientRect().top-(parseFloat(getComputedStyle(pin).top)||105)+x,behavior:'auto'})}));
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',measure,{passive:true});desktop.addEventListener('change',measure);new ResizeObserver(measure).observe(pin);
  root.querySelector('a[href="#gc-work"]').addEventListener('click',e=>{e.preventDefault();root.querySelector('#gc-work').scrollIntoView({behavior:paused?'auto':'smooth',block:'start'})});
  setMotion();document.fonts.ready.then(measure);window.addEventListener('load',measure,{once:true});
 };
 document.querySelectorAll('.gnd-custom').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.gnd-custom').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnd-featured-pieces"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gnd-feature-video')) {
    customElements.define('gnd-feature-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.userPaused = false;
        this.manualPlay = false;
        this.updateButton = () => {
          const playing = !this.video.paused;
          this.classList.toggle('is-playing', playing);
          this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
        };
        this.loadVideo = () => {
          if (!this.video.hasAttribute('src') && this.video.dataset.source) {
            this.video.muted = true;
            this.video.src = this.video.dataset.source;
          }
        };
        this.playVideo = () => {
          this.loadVideo();
          this.video.play().catch(this.updateButton);
        };
        this.syncPlayback = () => {
          const allowAuto = !this.reducedMotion.matches && !navigator.connection?.saveData;
          if (this.inView && !document.hidden && !this.userPaused && (allowAuto || this.manualPlay)) this.playVideo();
          else this.video.pause();
        };
        this.video.addEventListener('play', this.updateButton, {signal});
        this.video.addEventListener('pause', this.updateButton, {signal});
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.manualPlay = true;
            this.playVideo();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, {signal});
        document.addEventListener('visibilitychange', this.syncPlayback, {signal});
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, {threshold:0.2});
        this.observer.observe(this);
        this.updateButton();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.video?.pause();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnd-nameplate-launch"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gnd-nameplate-cinema'))customElements.define('gnd-nameplate-cinema',class extends HTMLElement{
 connectedCallback(){
  this.shots=[...this.querySelectorAll('[data-scene]')];this.button=this.querySelector('button');this.index=0;this.visible=false;this.manualPause=false;this.explicitPlay=false;this.elapsed=0;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.events=new AbortController();const opts={signal:this.events.signal};this.button.hidden=false;
  this.update=()=>{const run=this.visible&&!document.hidden&&!this.manualPause&&(!this.motion.matches||this.explicitPlay);this.running=run;this.closest('section').classList.toggle('is-paused',!run);this.button.textContent=run?this.button.dataset.pause:this.button.dataset.play;this.button.setAttribute('aria-label',this.button.textContent);};
  this.button.addEventListener('click',()=>{this.manualPause=this.running;this.explicitPlay=!this.running;this.update()},opts);
  document.addEventListener('visibilitychange',this.update,opts);this.motion.addEventListener('change',this.update,opts);
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update()},{threshold:.2});this.observer.observe(this);
  this.timer=setInterval(()=>{if(!this.running)return;this.elapsed+=250;if(this.elapsed<5000)return;this.elapsed=0;this.index=(this.index+1)%this.shots.length;this.shots.forEach((s,i)=>{s.classList.toggle('is-active',i===this.index);s.setAttribute('aria-hidden',String(i!==this.index))})},250);this.update();
 }
 disconnectedCallback(){clearInterval(this.timer);this.events?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnd-vault-reference"]) return;
  try {
    
if(!customElements.get('gnd-vault-reference')){
  customElements.define('gnd-vault-reference',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      const source=document.getElementById('gnd-vault-data');if(!source)return;
      try{this.catalog=JSON.parse(source.textContent);}catch{return;}
      this.ready=true;this.controller=new AbortController();const events={signal:this.controller.signal};
      this.querySelectorAll('product-form').forEach(wrapper=>{
        wrapper.addEventListener('cart:error',event=>{const note=wrapper.querySelector('[role="alert"]');note.textContent=event.detail.error;note.hidden=false;},events);
        wrapper.addEventListener('submit',()=>{wrapper.querySelector('[role="alert"]').hidden=true;},events);
      });
      this.dialog=this.querySelector('dialog');this.selection=this.querySelector('#GndReferencePiece');this.returnFocus=null;
      this.querySelectorAll('[data-inquire]').forEach(a=>a.addEventListener('click',event=>{event.preventDefault();this.inquire(a.dataset.inquire,a);},events));
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),events);
      this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';this.returnFocus?.focus({preventScroll:true});},events);
      this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const b=this.dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();},events);
      const piece=new URL(location.href).searchParams.get('piece');
      if(piece&&/^\d+$/.test(piece)){const card=this.querySelector('[data-piece="'+piece+'"]');if(card){card.classList.add('is-selected');requestAnimationFrame(()=>card.scrollIntoView({block:'center',behavior:'instant'}));}}
      if(this.querySelector('[data-form-errors],[data-form-success]'))this.open();
    }
    disconnectedCallback(){this.controller?.abort();this.ready=false;}
    open(trigger){this.returnFocus=trigger||document.activeElement;this.oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';if(!this.dialog.open)this.dialog.showModal();}
    inquire(key,trigger){const r=this.catalog.records.find(r=>r.key===key&&r.sku===this.dataset.reference);if(!r)return;this.selection.value='Reference '+r.sku+(r.piece?' · #'+r.piece:'')+' · '+r.karat+'KT '+r.color+' gold Cuban '+r.type.toLowerCase()+'\nWeight: '+r.grams+'g · Width: '+r.width+'mm · Length: '+r.length+' inches';this.open(trigger);}
  });
}

  } catch(e) { console.error(e); }
})();
})();
